AuthRoute = require 'mixins/authenticated-route'

App.BonusCategoriesRoute = Em.Route.extend AuthRoute,
  actions:
    goBackToBonusCategoriesList: ->
      @transitionTo 'bonus-categories'
      false
